<!-- Форма добавления комментария к пометке по ТС. -->
<template>
  <form
    :id="formId"
    class="vehicle-remark-comment-form"
    @submit.prevent="handleSubmit"
  >
    <BaseFormField
      v-if="showFiles"
      v-show="showFiles"
      for-id="fleet-vehicle-remark-comment-files"
      wide
    >
      <AttachmentUploader
        v-model:attachment-ids="form.attachment_ids"
        :key="form.uploaderKey"
        attachable-type="Comment"
        requisite-code="fleet-vehicle-remark-comment"
        :form-id="formId"
        @upload-state-changed="uploadsBlocked = $event.hasBlockingUploads"
      />
    </BaseFormField>

    <BaseFormField
      class="vehicle-remark-comment-form__field"
      for-id="vehicle-remark-comment-text"
      :error="errors.text"
      error-message="Напишите комментарий"
      wide
    >
      <base-textarea
        id="vehicle-remark-comment-text"
        v-model="form.text"
        class="vehicle-remark-comment-form__textarea"
        placeholder="Написать комментарий"
        :class="{ 'invalid': errors.text }"
        @keydown="handleCommentKeydown"
        @update:modelValue="errors.text = false"
      />
    </BaseFormField>

    <div class="vehicle-remark-comment-form__footer">
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="isSubmitting || uploadsBlocked"
      >
        Оставить комментарий
      </base-primary-button>

      <button
        type="button"
        class="vehicle-remark-comment-form__files-toggle"
        @click="showFiles = !showFiles"
      >
        <AppIcon name="paperclip" :size="12" />
        {{ showFiles ? "Скрыть файлы" : "Прикрепить файл" }}
        <span v-if="form.attachment_ids.length">
          · {{ form.attachment_ids.length }}
        </span>
      </button>
    </div>
  </form>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import AttachmentUploader from "@/components/Attachment/Uploader.vue";

const blankForm = () => ({
  text: "",
  attachment_ids: [],
  uploaderKey: Date.now(),
});

export default {
  name: "VehicleRemarkCommentsForm",

  components: {
    AppIcon,
    AttachmentUploader,
  },

  props: {
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    formId: {
      type: String,
      default: "vehicle-remark-comment-form",
    },
  },

  emits: ["submit"],

  data() {
    return {
      showFiles: false,
      uploadsBlocked: false,
      form: blankForm(),
      errors: {
        text: false,
      },
    };
  },

  methods: {
    handleSubmit() {
      if (this.isSubmitting || this.uploadsBlocked || !this.validateForm()) return;

      this.$emit("submit", {
        payload: {
          text: this.form.text,
          attachment_ids: this.form.attachment_ids,
        },
        resetForm: this.resetForm,
      });
    },

    handleCommentKeydown(event) {
      if (!event.shiftKey || event.key !== "Enter") return;

      event.preventDefault();
      event.target.form?.requestSubmit();
    },

    validateForm() {
      this.errors.text = !this.form.text.trim();

      return !this.errors.text;
    },

    resetForm() {
      this.form = blankForm();
      this.showFiles = false;
      this.uploadsBlocked = false;
    },

  },
};
</script>

<style scoped>
.vehicle-remark-comment-form {
  display: grid;
  gap: 10px;
}

.vehicle-remark-comment-form :deep(.dropzone) {
  margin-bottom: 8px;
  padding: 14px;
}

.vehicle-remark-comment-form :deep(.dropzone-content) {
  gap: 8px;
}

.vehicle-remark-comment-form :deep(.attachments-container) {
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.vehicle-remark-comment-form__field {
  margin-bottom: 0;
}

.vehicle-remark-comment-form__textarea {
  min-height: 42px;
  max-height: 120px;
  padding-top: 9px;
  padding-bottom: 9px;
}

.vehicle-remark-comment-form__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.vehicle-remark-comment-form__files-toggle {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
  color: #64748b;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.vehicle-remark-comment-form__files-toggle:hover {
  color: var(--color-green-hover);
}
</style>
